export const WORLD_CUP_START_DATE = "2026-06-11T00:00:00-04:00";

export type WorldCupCountdownParts = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

export function getWorldCupCountdownParts(now = Date.now()): WorldCupCountdownParts {
  const target = new Date(WORLD_CUP_START_DATE).getTime();
  const diff = Math.max(0, target - now);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  return { days, hours, minutes, seconds };
}

export function getWorldCupHeroCountdownDays(now = Date.now()) {
  const target = new Date(WORLD_CUP_START_DATE).getTime();
  const diff = Math.max(0, target - now);
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

export const WORLD_CUP_CATEGORY_LABELS = [
  "Hírek",
  "Csoportok",
  "Menetrend",
  "Válogatottak",
  "Taktika",
  "Esélylatolgatás",
  "Játékosok",
  "Visszhang",
  "Történelem",
] as const;
